/**
 * Handles the collapsibles component
 *
 * Based on https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html,
 * to ensure WCAG AA compliance
 */
 ;(function() {
	"use strict";

	function Collapsibles(section)
	{
		var controls = null;

		var fn = {
			init: function ()
			{
				var controlsNodeList = section.querySelectorAll('.collapsibles__control');
				controls = Array.prototype.slice.call(controlsNodeList);
				controlsNodeList.forEach(function (control) {
					control.addEventListener('click', fn.onClick);
				});

				section.addEventListener('keydown', fn.onKeydown);
			},

			onClick: function(event)
			{
				event.preventDefault();

				const eventTarget = event.target;
				const target = eventTarget.closest('.collapsibles__control');
				const active = section.querySelector('[aria-expanded="true"]');

				var isExpanded = target.getAttribute('aria-expanded') == 'true';

				if (active && active !== target) {
					active.setAttribute('aria-expanded', 'false');
					document.getElementById(active.getAttribute('aria-controls')).setAttribute('hidden', '');
				}

				if (!isExpanded) {
					target.setAttribute('aria-expanded', 'true');
					document.getElementById(target.getAttribute('aria-controls')).removeAttribute('hidden');

					// If the top of the target is out of view, scroll to it
					if (target.getBoundingClientRect().top < 0) {
						target.scrollIntoView();
					}
				} else {
					target.setAttribute('aria-expanded', 'false');
					document.getElementById(target.getAttribute('aria-controls')).setAttribute('hidden', '');
				}
			},

			onKeydown: function(event)
			{
				const target = event.target;
				const key = event.which.toString();

				// 33 = Page Up, 34 = Page Down
				const ctrlModifier = (event.ctrlKey && key.match(/33|34/));

				// Is this coming from an accordion header?
				if (target.classList.contains('collapsibles__control')) {
					// Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
					// 38 = Up, 40 = Down
					if (key.match(/38|40/) || ctrlModifier) {
						const index = controls.indexOf(target);
						const direction = (key.match(/34|40/)) ? 1 : -1;
						const length = controls.length;
						const newIndex = (index + length + direction) % length;

						controls[newIndex].focus();
						event.preventDefault();
					}
					else if (key.match(/35|36/)) {
						// 35 = End, 36 = Home keyboard operations
						switch (key) {
							// Go to first accordion
							case '36':
								controls[0].focus();
								break;
								// Go to last accordion
							case '35':
								controls[controls.length - 1].focus();
								break;
						}
						event.preventDefault();
					}
				  }
			}
		}

		fn.init();
	}

	document.querySelectorAll('.collapsibles').forEach(function (section) {
		new Collapsibles(section);
	});
})();